import Cookies from "js-cookie";
import http from "utils/http";

// 获取 主体业态 列表
export function getEntityTypeList() {
    return http({
        url: '/warning/common/entitytype',
        method: 'get',
    });
}

// 获取 不同预警主体统计
export function getStatistics(data) {
    return http({
        url: '/warning/summary/entity/statistics',
        method: 'post',
        data,
    });
}

// 获取 主体信息
export function getEntity(params) {
    return http({
        url: '/warning/common/entity',
        method: 'get',
        params,
    });
}

// 获取 预警详情页统计数据
export function getDetailStatistics(params) {
    return http({
        url: '/warning/summary/detail/statistics',
        method: 'get',
        params,
    });
}

// 预警处理 监管端处理时的分数范围
export function getRecordScore(params) {
    return http({
        url: '/warning/record/score',
        method: 'get',
        params,
    });
}

// 预警处理 重新处理回显
export function getRecordBack(params) {
    return http({
        url: '/warning/record/back',
        method: 'get',
        params,
    });
}

// 获取预警类型扣分规则
export function getHint(params) {
    params.areaCode = Cookies.get('areaId');
    return http({
        url: '/warning/common/hint',
        method: 'get',
        params,
    });
}

// 获取处理状态
export function getHandleStatus() {
    return http({
        url: '/warning/common/handlestatus',
        method: 'get',
    });
}

// 获取 处理方式
export function getHandleType(params) {
    return http({
        url: '/warning/common/handletype',
        method: 'get',
        params,
    });
}

// 获取 处理部门
export function getHandleDept() {
    return http({
        url: '/warning/common/handledept',
        method: 'get',
    });
}

// 获取 获取预警类型 （异常类型）
// 预警类型 0101->食品预警 0102->溯源预警 0103->后厨管理异常预警 0202->AI摄像头预警 0301->监管检查预警 0302->健康证预警 0303->许可证预警 0401->投诉建议预警
export function getType(params) {
    return http({
        url: '/warning/common/type',
        method: 'get',
        params,
    });
}

// 预警处理
export function setHandle(data, submitUrl) {
    return http({
        url: submitUrl,
        method: 'post',
        data,
    });
}

// 后厨预警主体分页
export function getChefEntityList(data) {
    return http({
        url: '/warning/chef/entity/page',
        method: 'post',
        data,
    });
}

// 后厨预警详情列表
export function getChefDetailList(data) {
    return http({
        url: '/warning/chef/detail/page',
        method: 'post',
        data,
    });
}


// 食品预警主体分页
export function getFoodEntityList(data) {
    return http({
        url: '/warning/food/entity/page',
        method: 'post',
        data,
    });
}

// 食品预警详情分页
export function getFoodDetailList(data) {
    return http({
        url: '/warning/food/detail/page',
        method: 'post',
        data,
    });
}

// AI预警主体分页
export function getAIEntityList(data) {
    return http({
        url: '/warning/ai/entity/page',
        method: 'post',
        data,
    });
}

// AI预警详情列表
export function getAIDetailList(data) {
    return http({
        url: '/warning/ai/detail/page',
        method: 'post',
        data,
    });
}

// AI预警详情
export function getAIDetail(data) {
    return http({
        url: '/warning/ai/detail',
        method: 'post',
        data,
    });
}

// 监管检查预警主体分页
export function getPatrolEntityList(data) {
    return http({
        url: '/warning/patrol/entity/page',
        method: 'post',
        data,
    });
}

// 监管检查预警详情分页
export function getPatrolDetailList(data) {
    return http({
        url: '/warning/patrol/detail/page',
        method: 'post',
        data,
    });
}

// 监督检查预警处理之前验证是否复查 (false 表示 该预警的来源复查记录还未复查不能处理该预警 则表示该预警不能处理)
export function getPatrolVerify(params) {
    return http({
        url: '/warning/patrol/getPatrolId',
        method: 'get',
        params,
    });
}

// 投诉建议预警主体分页
export function getComplaintEntityList(data) {
    return http({
        url: '/warning/complaint/entity/page',
        method: 'post',
        data,
    });
}

// 投诉建议详情分页
export function getComplaintDetailList(data) {
    return http({
        url: '/warning/complaint/detail/page',
        method: 'post',
        data,
    });
}

// 检测异常预警主体分页
export function getCheckEntityList(data) {
    return http({
        url: '',
        method: 'post',
        data,
    });
}

// 检测异常详情分页
export function getCheckDetailList(data) {
    return http({
        url: '',
        method: 'post',
        data,
    });
}

// 健康证预警主体分页
export function getHealthEntityList(data) {
    return http({
        url: '/warning/health/entity/page',
        method: 'post',
        data,
    });
}

// 健康证预警详情
export function getHealthDetailList(data) {
    return http({
        url: '/warning/health/detail/page',
        method: 'post',
        data,
    });
}

// 许可证预警主体分页
export function getLicenseEntityList(data) {
    return http({
        url: '/warning/license/entity/page',
        method: 'post',
        data,
    });
}

// 许可证预警详情
export function getLicenseDetailList(data) {
    return http({
        url: '/warning/license/detail/page',
        method: 'post',
        data,
    });
}

// 溯源预警主体分页
export function getOriginEntityList(data) {
    return http({
        url: '/warning/origin/entity/paging',
        method: 'post',
        data,
    });
}

// 溯源预警详情
export function getOriginDetailList(data) {
    return http({
        url: '/warning/origin/detail/page',
        method: 'post',
        data,
    });
}

// 溯源预警详情
export function getStatisticsList(data) {
    return http({
        url: '/warning/statistics?entityId=' + data.entityId,
        method: 'post',
        data,
    });
}

// TogWeb端H5预警中心的预警类型下拉框 (获取菜单)
export function getWarningTypeByEntityId(params) {
    return http({
        url: '/entity/warning/type',
        method: 'get',
        params,
    });
}